<template>
  <v-form ref="loginForm" v-model="valid">
    <v-text-field
      v-model="email"
      prepend-icon="mdi-email"
      name="email"
      label="Email"
      type="email"
      :rules="emailRules"
      required
      @input="userLoginError = ''"
    />
    <v-text-field
      v-model="password"
      prepend-icon="mdi-lock"
      name="password"
      label="Password"
      type="password"
      required
      :rules="passwordRules"
      @input="userLoginError = ''"
      @keydown.enter.stop="submitLogin"
    />
    <p
      :style="{ visibility: userLoginError ? 'visible' : 'hidden' }"
      class="text-center error--text"
    >
      {{ userLoginError }}
    </p>
    <v-btn
      block
      color="primary"
      :disabled="!valid"
      :loading="loginButtonLoading"
      @click="submitLogin"
    >
      Submit
    </v-btn>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      emailRules: [
        v => !!v || "The email field cannot be empty",
        v => /.+@.+\..+/.test(v) || "The email address is not valid"
      ],
      passwordRules: [v => !!v || "The password field cannot be empty"],
      valid: false
    };
  },
  computed: {
    userLoginError: {
      get: function() {
        return this.$store.state.userLoginError;
      },
      set: function(newValue) {
        this.$store.state.userLoginError = newValue;
      }
    },
    loginButtonLoading: {
      get: function() {
        return this.$store.state.loginButtonLoading;
      },
      set: function(value) {
        this.$store.state.loginButtonLoading = value;
      }
    }
  },
  methods: {
    submitLogin() {
      if (this.$refs.loginForm.validate()) {
        this.loginButtonLoading = true;
        this.$store
          .dispatch("userLogin", {
            email: this.email,
            password: this.password
          })
          .then(() => {
            const user = this.$store.state.user;
            if (user) {
              this.$refs.loginForm.reset();
              if (user.admin || (user.emailVerified && user.accessGranted)) {
                this.$router.push("/explore");
              } else {
                this.$router.push("/application-status");
              }
            }
          });
      }
    }
  }
};
</script>
